import { AlertTriangle, Wrench, FolderKanban, RefreshCw, ShoppingCart } from "lucide-react";

export const PRIO = {
  P1: { label: "P1 — Urgent", impact: "100% of functions and/or all users affected", examples: "Network/email outage, company-wide critical app (e.g. QuickBooks) down", response: "Response within 1 hour", cls: "text-rose-300 bg-rose-950/60 border-rose-800" },
  P2: { label: "P2 — High", impact: "50–99% of business-critical functions and/or users affected", examples: "Wi‑Fi down, site-to-site VPN down, password resets/unlocks, computer failure", response: "Response within 2 hours", cls: "text-orange-300 bg-orange-950/50 border-orange-800" },
  P3: { label: "P3 — Medium", impact: "25–49% of business-critical functions and/or users affected", examples: "Business-critical app failure for a single user, VPN failure for a user", response: "Response within 4 hours", cls: "text-amber-300 bg-amber-950/40 border-amber-800" },
  P4: { label: "P4 — Low", impact: "1–24% of business-critical functions and/or users affected", examples: "Software issues, printing problems, feature additions/changes", response: "Response within 8 hours", cls: "text-sky-300 bg-sky-950/40 border-sky-800" },
};
export const PRIORITIES = ["P1", "P2", "P3", "P4"];
export const TYPE_META = {
  Incident: { icon: AlertTriangle, cls: "text-rose-400", desc: "Something is broken, degraded, or potentially compromised" },
  "Service Request": { icon: Wrench, cls: "text-cyan-400", desc: "Routine user/customer requests (resets, installs, onboarding)" },
  Project: { icon: FolderKanban, cls: "text-violet-400", desc: "Planned work with a defined scope / deliverable" },
  "Change / Maintenance": { icon: RefreshCw, cls: "text-amber-400", desc: "Planned changes to an existing environment" },
  Procurement: { icon: ShoppingCart, cls: "text-emerald-400", desc: "Purchasing, licensing, or sourcing" },
};
export const TYPES = ["Incident", "Service Request", "Project", "Change / Maintenance", "Procurement"];
export const REPLY_STATUS = {
  "Unread": "text-rose-300 bg-rose-950/50 border-rose-800",
  "Read": "text-slate-300 bg-slate-800 border-slate-700",
  "Awaiting Technician Response": "text-amber-300 bg-amber-950/50 border-amber-800",
  "Awaiting Customer Response": "text-sky-300 bg-sky-950/50 border-sky-800",
};
export const STATUSES = ["New", "Open", "Pending Customer", "Pending Vendor", "Scheduled", "Resolved", "Closed"];
export const IMPACT = [
  { p: "P1", label: "100% — all users / functions affected" },
  { p: "P2", label: "50–99% of users / functions affected" },
  { p: "P3", label: "25–49% of users / functions affected" },
  { p: "P4", label: "1–24% of users / functions affected" },
];
export const TYPE_DEFAULT_PRIO = { Incident: "P3", "Service Request": "P4", Project: "P4", "Change / Maintenance": "P4", Procurement: "P4" };

export function dueLabel(iso, breached) {
  if (!iso) return null;
  const diff = new Date(iso) - new Date();
  const mins = Math.round(Math.abs(diff) / 60000);
  const txt = mins >= 60 ? `${Math.round(mins / 60)}h` : `${mins}m`;
  return breached ? `overdue ${txt}` : `in ${txt}`;
}
